/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Frontend SPA Contract API
 * Canonical API contract entrypoint.
 *
 * Source architecture:
 * - split by module / bounded context
 * - one file per aggregate root
 * - child entities remain owned by aggregate root
 * - cross-cutting technical concerns live under `openapi/common`
 *
 * OpenAPI spec version: 1.0.0
 */
import type {CatalogItemId, NoteId, NoteInput} from "../model";

import {customFetch} from "../../../runtime/custom-fetch";

export const getAddMaterialNoteUrl = (id: CatalogItemId) => {
  return `/api/v1/engineering/materials/${id}/notes`;
};

/**
 * @summary Add material note
 */
export const addMaterialNote = async (
  id: CatalogItemId,
  noteInput: NoteInput,
  options?: Parameters<typeof customFetch>[1],
): Promise<NoteId> => {
  return customFetch<NoteId>(getAddMaterialNoteUrl(id), {
    ...options,
    method: "POST",
    headers: {"Content-Type": "application/json", ...options?.headers},
    body: JSON.stringify(noteInput),
  });
};

export const getEditMaterialNoteUrl = (id: CatalogItemId, noteId: NoteId) => {
  return `/api/v1/engineering/materials/${id}/notes/${noteId}`;
};

/**
 * @summary Edit material note
 */
export const editMaterialNote = async (
  id: CatalogItemId,
  noteId: NoteId,
  noteInput: NoteInput,
  options?: Parameters<typeof customFetch>[1],
): Promise<void> => {
  return customFetch<void>(getEditMaterialNoteUrl(id, noteId), {
    ...options,
    method: "PUT",
    headers: {"Content-Type": "application/json", ...options?.headers},
    body: JSON.stringify(noteInput),
  });
};

export const getRemoveMaterialNoteUrl = (id: CatalogItemId, noteId: NoteId) => {
  return `/api/v1/engineering/materials/${id}/notes/${noteId}`;
};

/**
 * @summary Remove material note
 */
export const removeMaterialNote = async (
  id: CatalogItemId,
  noteId: NoteId,
  options?: Parameters<typeof customFetch>[1],
): Promise<void> => {
  return customFetch<void>(getRemoveMaterialNoteUrl(id, noteId), {
    ...options,
    method: "DELETE",
  });
};
